import { useEffect, useState } from 'react';
import axios from '../../../lib/axios';
import {
  CATEGORIES_DELETE,
  CATEGORIES_FIND_MANY,
  DIVISION_DELETE,
  DIVISION_FIND_MANY,
  MASTER_CATEGORIES_FIND_MANY,
  MASTER_DIVISION_FIND_MANY,
  MASTER_SUB_CATEGORIES_FIND_MANY,
  SUB_CATEGORY_DELETE,
  SUB_CATEGORY_FIND_MANY,
} from '../../../lib/endpoints/category';
import { DivisionModel } from '../../../models/division';
import { SuppliesDivisionModel } from '../../../models/suppliesDivisionModel';
import { CategoryModel } from '../../../models/category';
import { SuppliesCategoryProduct } from '../../../models/suppliesCategoryProduct';
import { SuppliesProductSubCategory } from '../../../models/suppliesSubCategory';
import { SubCategoryModel } from '../../../models/subCategory';
// -----------------------------------------------------------------------

interface DataFormViewType{
  title:string;
  code:string;
  imageUrl:string;
  nameEn:string;
  nameLa:string;
}
interface Props {
  mainGroupId: string;
  masterMainGroupId: string;
}

const useMainGroupController = ({ mainGroupId, masterMainGroupId }: Props) => {
  // variables
  const [loading, setLoading] = useState<boolean>(true);

  const [dataMasterDivision, setDataMasterDivision] = useState<SuppliesDivisionModel[]>([]);
  const [dataFormView,setDataFormView]=useState<DataFormViewType>(null!);

  const [dataDivision, setDataDivision] = useState<DivisionModel[]>([]);
  const [selectedDivision, setSelectedDivision] = useState<DivisionModel>(null!);
  const [openDivisionForm, setOpenDivisionForm] = useState<boolean>(false);
  const [selectedDeleteDivisionId, setSelectedDeleteDivisionId] = useState<string>(null!);
  const [loadingDeleteDivision, setLoadingDeleteDivision] = useState<boolean>(false);

  const [loadingDeleteCategory, setLoadingDeleteCategory] = useState<boolean>(false);
  const [dataCategory, setDataCategory] = useState<CategoryModel[]>([]);
  const [dataMasterCategory, setDataMasterCategory] = useState<SuppliesCategoryProduct[]>([]);
  const [openCategoryForm, setOpenCategoryForm] = useState<boolean>(false);
  const [loadingGetCategory, setLoadingGetCategory] = useState<boolean>(false);
  const [selectedDeleteCategoryId, setSelectedDeleteCategoryId] = useState<string>(null!);
  const [selectedCategory, setSelectedCategory] = useState<CategoryModel>(null!);

  const [loadingGetSubCategory, setLoadingGetSubCategory] = useState<boolean>(false);
  const [dataMasterSubCategory, setDataMasterSubCategory] = useState<SuppliesProductSubCategory[]>(
    []
  );
  const [dataSubCategory, setDataSubCategory] = useState<SubCategoryModel[]>([]);
  const [openSubCategoryForm, setOpenSubCategoryForm] = useState<boolean>(false);
  const [selectedDeleteSubCategoryId, setSelectedDeleteSubCategoryId] = useState<string>(null!);
  const [loadingDeleteSubCategory, setLoadingDeleteSubCategory] = useState<boolean>(false);

  // functions

  const handleCloseDataFormView=()=>{
    setDataFormView(null!);
  }

  const handleOpenDataFormView=(getData:DataFormViewType)=>{
    setDataFormView(getData);;
  }

  const handleGetDataDivision = async () => {
    try {
      setLoading(true);
      const res = await axios.post(DIVISION_FIND_MANY, {
        filter: {
          main_group_name_id: mainGroupId,
        },
      });
      const resMasterDivision = await axios.post(MASTER_DIVISION_FIND_MANY, {
        filter: {
          supplies_main_group_name_id: masterMainGroupId,
        },
      });

      setDataMasterDivision(resMasterDivision?.data);
      setDataDivision(res?.data?.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDeleteDivision = (id: string) => {
    setSelectedDeleteDivisionId(id);
  };



  const handleCloseDivisionForm = () => {
    setOpenDivisionForm(false);
  };

  const handleCloseDeleteDivisionDialog = () => {
    setSelectedDeleteDivisionId(null!);
  };

  const handleCloseCategoryForm = () => {
    setOpenCategoryForm(false);
  };

  const handleOpenCategoryForm = () => {
    setOpenCategoryForm(true);
  };

  const handleOpenDeleteCategoryDialog = (getId: string) => {
    setSelectedDeleteCategoryId(getId);
  };

  const handleCloseDeleteCategoryDialog = () => {
    setSelectedDeleteCategoryId(null!);
  };

  const handleDeleteDivision = async () => {
    try {
      setLoadingDeleteDivision(true);
      await axios.delete(DIVISION_DELETE + `?id=${selectedDeleteDivisionId}`);
      setDataDivision(dataDivision?.filter((item) => item?.id !== selectedDeleteDivisionId));
      handleCloseDeleteDivisionDialog();
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingDeleteDivision(false);
    }
  };

  const handleSelectDivision = async (newValue: DivisionModel) => {
    setSelectedDivision(newValue);
    try {
      setLoadingGetCategory(true);
      const res = await axios.post(CATEGORIES_FIND_MANY, {
        filter: {
          division_name_id: newValue?.id,
        },
      });
      const resMasterCategories = await axios.post(MASTER_CATEGORIES_FIND_MANY, {
        filter: {
          supplies_division_name_id: newValue?.supplies_division_name?.id,
        },
      });
      setDataMasterCategory(resMasterCategories?.data);
      setDataCategory(res?.data?.data);
    } catch (err) {
    } finally {
      setLoadingGetCategory(false);
      setSelectedCategory(null!)
    }
  };

  const handleSelectCategory = async (newValue: CategoryModel) => {
    console.log('newValue=', newValue);
    setSelectedCategory(newValue);
    try {
      setLoadingGetSubCategory(true);
      const res = await axios.post(SUB_CATEGORY_FIND_MANY, {
        filter: {
          product_category_id: newValue?.id,
        },
      });
      const resMasterSubCategories = await axios.post(MASTER_SUB_CATEGORIES_FIND_MANY, {
        filter: {
          supplies_product_category_id: newValue?.supplies_product_category?.id,
        },
      });
      setDataMasterSubCategory(resMasterSubCategories?.data);
      setDataSubCategory(res?.data?.data);
    } catch (err) {
    } finally {
      setLoadingGetSubCategory(false);
    }
  };

  const handleRefetchSubCategory = async () => {
    try {
      setLoadingGetSubCategory(true);
      const res = await axios.post(SUB_CATEGORY_FIND_MANY, {
        filter: {
          product_category_id: selectedCategory?.id,
        },
      });
      setDataSubCategory(res?.data?.data);
    } catch (err) {
    } finally {
      setLoadingGetSubCategory(false);
    }
  };

  const handleRefetchCategory = async () => {
    try {
      setLoadingGetCategory(true);
      const res = await axios.post(CATEGORIES_FIND_MANY, {
        filter: {
          division_name_id: selectedDivision?.id,
        },
      });
      setDataCategory(res?.data?.data);
    } catch (err) {
    } finally {
      setLoadingGetCategory(false);
    }
  };

  const handleDeleteCategory = async () => {
    try {
      setLoadingDeleteCategory(true);
      await axios.delete(CATEGORIES_DELETE + `?id=${selectedDeleteCategoryId}`);
      setDataCategory(dataCategory?.filter((item) => item?.id !== selectedDeleteCategoryId));
      handleCloseDeleteCategoryDialog();
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingDeleteCategory(false);
    }
  };

  const handleOpenSubCategoryForm = () => {
    setOpenSubCategoryForm(true);
  };

  const handleCloseSubCategoryForm = () => {
    setOpenSubCategoryForm(false);
  };

  const handleCloseDeleteSubCategoryDialog = () => {
    setSelectedDeleteSubCategoryId(null!);
  };

  const handleDeleteSubCategory = async () => {
    try {
      setLoadingDeleteSubCategory(true);
      await axios.delete(SUB_CATEGORY_DELETE + `?id=${selectedDeleteSubCategoryId}`);
      setDataSubCategory(
        dataSubCategory?.filter((item) => item?.id !== selectedDeleteSubCategoryId)
      );
      handleCloseDeleteSubCategoryDialog();
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingDeleteSubCategory(false);
    }
  };

  const handleOpenDeleteSubCategoryDialog = (id: string) => {
    console.log('id=',id)
    setSelectedDeleteSubCategoryId(id);
  };

  // useEffect
  useEffect(() => {
    handleGetDataDivision();
  }, []);
  // return
  return {
    loading,
    dataDivision,
    selectedDivision,
    handleOpenDeleteDivision,
    handleOpenFormDivision: () => setOpenDivisionForm(true),
    openDivisionForm,
    handleSelectDivision,
    handleCloseDivisionForm,
    dataMasterDivision,
    handleGetDataDivision,
    selectedDeleteDivisionId,
    loadingDeleteDivision,
    handleCloseDeleteDivisionDialog,
    handleDeleteDivision,
    loadingGetCategory,
    dataCategory,
    openCategoryForm,
    handleCloseCategoryForm,
    handleOpenCategoryForm,
    dataMasterCategory,
    handleOpenDeleteCategoryDialog,
    handleCloseDeleteCategoryDialog,
    selectedDeleteCategoryId,
    loadingDeleteCategory,
    handleDeleteCategory,
    handleRefetchCategory,
    selectedCategory,
    handleSelectCategory,
    dataSubCategory,
    loadingGetSubCategory,
    openSubCategoryForm,
    handleOpenSubCategoryForm,
    dataMasterSubCategory,
    handleCloseSubCategoryForm,
    handleRefetchSubCategory,
    selectedDeleteSubCategoryId,
    loadingDeleteSubCategory,
    handleCloseDeleteSubCategoryDialog,
    handleDeleteSubCategory,
    handleOpenDeleteSubCategoryDialog,
    dataFormView,
    handleCloseDataFormView,
    handleOpenDataFormView
  };
};
export default useMainGroupController;
